/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
import { PermissionDescriptorFromJSON, PermissionDescriptorToJSON, } from './PermissionDescriptor';
/**
 * Check if a given object implements the RoleResponse interface.
 */
export function instanceOfRoleResponse(value) {
    var isInstance = true;
    return isInstance;
}
export function RoleResponseFromJSON(json) {
    return RoleResponseFromJSONTyped(json, false);
}
export function RoleResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionDescriptorFromJSON))
    };
}
export function RoleResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'id': value.id,
        'description': value.description,
        'metaData': MetaDataToJSON(value.metaData),
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionDescriptorToJSON))
    };
}
